import { render } from "./OrderRatio.vue?vue&type=template&id=40cc16f3&scoped=true"
import script from "./OrderRatio.vue?vue&type=script&lang=js"
export * from "./OrderRatio.vue?vue&type=script&lang=js"

import "./OrderRatio.vue?vue&type=style&index=0&id=40cc16f3&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cc16f3"]])

export default __exports__